import { WORDFENCE_KEY_LIMIT, type WebhookStatus, type WordfenceStatus } from '@ametica/shared';

/**
 * Stav katalógu na jeden pohľad. Vek sa meria od posledného ÚSPEŠNÉHO production
 * syncu (scanner obsah nepotvrdzuje); prázdny katalóg je vždy zlý stav, nie „nula nálezov".
 */
export type CatalogTone = 'ok' | 'stale' | 'bad' | 'empty';

export interface CatalogState {
  tone: CatalogTone;
  label: string;
}

const HOUR = 3600_000;
/** production feed ide 1×/deň — po 26 h bez úspechu už jeden beh chýba */
export const STALE_AFTER_MS = 26 * HOUR;
export const OLD_AFTER_MS = 72 * HOUR;

export function catalogState(s: Pick<WordfenceStatus, 'catalog' | 'lastProductionSyncAt' | 'key'>, now = Date.now()): CatalogState {
  if (s.key.breakerOpen) return { tone: 'bad', label: 'Kľúč je vypnutý' };
  if (!s.key.configured) return { tone: 'bad', label: 'Kľúč nie je nastavený' };
  if (s.catalog.total === 0) return { tone: 'empty', label: 'Katalóg je prázdny' };
  if (!s.lastProductionSyncAt) return { tone: 'stale', label: 'Production feed ešte nebol stiahnutý' };
  const age = now - new Date(s.lastProductionSyncAt).getTime();
  if (age > OLD_AFTER_MS) return { tone: 'bad', label: 'Katalóg je starý' };
  if (age > STALE_AFTER_MS) return { tone: 'stale', label: 'Denný sync mešká' };
  return { tone: 'ok', label: 'Katalóg aktuálny' };
}

export type SlotState = 'used' | 'free' | 'reserve';

/** 48 políčok: minuté, voľné do stropu 44, a 4 rezervné, ktoré aplikácia nikdy neminie. */
export function quotaSlots(usedToday: number, cap: number, limit = WORDFENCE_KEY_LIMIT): SlotState[] {
  return Array.from({ length: limit }, (_, i) => (i < Math.min(usedToday, cap) ? 'used' : i < cap ? 'free' : 'reserve'));
}

export function formatUtcTimes(times: string[]): string {
  return times.length ? `${times.join(', ')} UTC` : '—';
}

/**
 * Stav webhooku na jeden pohľad. „Pripojený" znamená len, že prišiel podpísaný event —
 * Wordfence posiela jednotky eventov denne, takže dlhé ticho nie je chyba. Chybný event
 * je stav, ktorý človek rieši (prehrať / pozrieť chybu), preto má prednosť pred vekom.
 */
export function webhookState(w: Pick<WebhookStatus, 'configured' | 'lastSeenAt' | 'failed' | 'pending'>): CatalogState {
  if (!w.configured) return { tone: 'bad', label: 'Secret nie je nastavený' };
  if (w.failed > 0) return { tone: 'stale', label: w.failed === 1 ? '1 chybný event' : `${w.failed} chybných eventov` };
  if (!w.lastSeenAt) return { tone: 'empty', label: 'Zatiaľ žiadny event' };
  if (w.pending > 0) return { tone: 'ok', label: `pripojený · ${w.pending} čaká` };
  return { tone: 'ok', label: 'pripojený' };
}
